angular.module('dashboard').controller('DashboardCtrl',
    ['$scope', 'DashboardService', 'MyChartService', 'PatientPortalStorageRepository',
        function ($scope, DashboardService, MyChartService, PatientPortalStorageRepository) {
            'use strict';

            $scope.loading = true;

            $scope.today = new Date();

            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();
                var activePatient = PatientPortalStorageRepository.getActivePatient();

                $scope.activeTiles = _(DashboardService.getPatientDashboardFeatures())
                    .filter('IsActive')
                    .sortBy('DisplayOrder')
                    .value();

                MyChartService.getDetails(activePatient.id)
                    .then(function (data) {
                        $scope.patient = {
                            userId: activePatient.id,
                            name: activePatient.fullName,
                            birthDate: data.DateOfBirth,
                            providerName: data.PrimaryProviderName,
                            serviceSite: data.PrimaryProviderServiceSite,
                            serviceSitePhoneNumber: data.PrimaryProviderServiceSitePhoneNumber,
                            serviceSiteAddress1: data.PrimaryProviderServiceSiteAddress1,
                            serviceSiteAddress2: data.PrimaryProviderServiceSiteAddress2,
                            serviceSiteLocation: data.PrimaryProviderServiceSiteLocation
                        };
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }
            loadPage();

            var notificationListener = $scope.$on('Notification:updated', function () {
                loadPage();
            });

            $scope.$on('$destroy', function () {
                notificationListener();
            });

        }
    ]
);